import { createEffect, createSignal, onCleanup, Show } from "solid-js";
import { requestBlob } from "../store/api-client";

export function AuthenticatedImage(props: { path: string; alt: string }) {
  const [source, setSource] = createSignal<string | null>(null);
  const [failed, setFailed] = createSignal(false);
  createEffect(() => {
    const path = props.path;
    const controller = new AbortController();
    let objectUrl: string | null = null;
    setSource(null);
    setFailed(false);
    void requestBlob(path, controller.signal)
      .then((blob) => {
        if (controller.signal.aborted) return;
        objectUrl = URL.createObjectURL(blob);
        setSource(objectUrl);
      })
      .catch(() => {
        if (!controller.signal.aborted) setFailed(true);
      });
    onCleanup(() => {
      controller.abort();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    });
  });
  return (
    <Show when={!failed()} fallback={<p>Image is unavailable.</p>}>
      <Show when={source()}>
        {(url) => (
          <img
            src={url()}
            alt={props.alt}
            loading="lazy"
            onError={() => setFailed(true)}
          />
        )}
      </Show>
    </Show>
  );
}
